<template>
    <div>

        <div v-if="editCursoSuperior && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitCursoSuperior" v-if="!editCursoSuperior || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editCursoSuperior || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                            <el-select v-model="dados.situacao">
                                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                <el-option :key="false" label="INATIVO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3" :md="3">
                        <el-form-item label="Código Área" prop="cod_area" :rules="[$requiredBlur]" key="cod_area">
                            <el-input v-model="dados.cod_area" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_area')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="18" :md="15">
                        <el-form-item label="Nome Área" prop="nome_area" :rules="[$requiredBlur]" key="nome_area">
                            <el-input v-model="dados.nome_area" maxlength="191" v-on:blur="formatData('nome_area')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3" :md="3">
                        <el-form-item label="Código OCDE" prop="cod_ocde" :rules="[$requiredBlur]" key="cod_ocde">
                            <el-input v-model="dados.cod_ocde" maxlength="191" v-on:blur="formatData('cod_ocde')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="15" :md="15">
                        <el-form-item label="Nome - Grau" prop="nome" :rules="[$requiredBlur]" key="nome">
                            <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Grau Acadêmico" prop="grau_academico" :rules="[$requiredChange]" key="grau_academico">
                            <el-select v-model="dados.grau_academico">
                                <el-option key="Tecnológico" label="Tecnológico" value="Tecnológico"></el-option>
                                <el-option key="Bacharelado" label="Bacharelado" value="Bacharelado"></el-option>
                                <el-option key="Licenciatura" label="Licenciatura" value="Licenciatura"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>  

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-ensino-superior-curso" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editCursoSuperior: false,
        alert: false,
        dados: {
            id: '',
            situacao: '',
            nome: ''
        }

    }),
    mounted () {

    },
    methods:{
        getCursoSuperiorById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ensino-superior-curso/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitCursoSuperior(){

            document.getElementById("btn-ensino-superior-curso").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                if(this.editCursoSuperior){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ensino-superior-curso/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        
                        this.$emit('onSubmitCursoSuperior');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ensino-superior-curso/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitCursoSuperior');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormCursoSuperior(){
          
            this.dados = { id: '', nome: '', descricao: '', ativa: '', emDestaque: null, imagem: '' };
            this.$refs.dados.clearValidate();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getCursoSuperiorById(value);
                    this.editCursoSuperior = true;
                } 
            }
        },
    }
}
</script>
